/**
 * Airship actions.
 */
export class AirshipActions {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Runs an Airship action.
     *
     * @param name The name of the action.
     * @param value The action's value.
     * @return A promise that returns the action result if the action
     * successfully runs, or the Error if the action was unable to be run.
     */
    run(actionName, actionValue) {
        return this.plugin.perform('actions#run', [actionName, actionValue]);
    }
}
//# sourceMappingURL=AirshipActions.js.map